<template>
  <div class="policy-item">
    <div class="policy-item__element policy-item__element--first">
      <vb-icon :name="icon" :color="sass('primary')" :size="16" class="mr-2" />
      <span class="policy-item__title semibold">{{ title }}</span>
    </div>
    <div class="policy-item__element policy-item__element--second">
      <div class="policy-item__conditions" v-if="detail.type === 'cots_and_extra_beds'">
        <p class="policy-item__conditions-title">Condizioni per culle e letti aggiuntivi</p>
        <p class="policy-item__conditions-subtitle">
          Qualsiasi tipo di letto supplementare o culla è disponibile su richiesta e previa conferma da parte della struttura.
        </p>
        <cots-extrabeds
          class="policy-item__cots"
          :extra="detail.content"
          :currency="detail.currency"
        />
      </div>
      <div class="policy-item__pets" v-else-if="detail.type === 'pets'">
        <span v-if="detail.content.allowed === 'no'">Animali non ammessi.</span>
        <span v-else>Animali ammessi su richiesta. Potrebbe essere richiesto un supplemento.</span>
      </div>
      <div class="policy-item__pets" v-else-if="detail.type === 'damage'">
        <span>{{ detail.content.currency }} {{ detail.content.amount }}</span>
      </div>
      <span v-else>{{ detail.content }}</span>
    </div>
  </div>
</template>

<script>
import CotsExtraBeds from '@bookingv3/components/blocks/cots-extrabeds'

export default {
  name: 'policy-item',

  components: {
    'cots-extrabeds': CotsExtraBeds,
  },

  props: {
    icon: String,
    title: String,
    detail: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .policy-item {
    border-bottom: 1px solid $gray-200;
    padding: $grid-gutter-width/2 0;
    display: flex;
    align-items: flex-start;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border: none;
      padding-bottom: 0;
    }

    &__element {

      &--first {
        flex-basis: 20%;
        display: flex;
        align-items: center;
      }

      &--second {
        flex-basis: 80%;
      }

      &-icon {
        &--in {
          transform: rotate(180deg);
        }
      }
    }

    &__conditions {

      &-title {
        margin-bottom: 0;
        font-weight: $vb-font-weight-semibold;
      }

      &-subtitle {
        margin-bottom: 0;
      }
    }

    &__cots {
      margin-top: $grid-gutter-width/2;

      &:empty {
        display: none;
      }
    }

    ::v-deep {

      .cots-extrabeds {

        &__item{
          flex-basis: 100%;

          @include media-breakpoint-up(lg){
            flex-basis: 50%;
          }

          @include media-breakpoint-up(xl){
            flex-basis: 33.33%;
          }
        }
      }
    }
  }

</style>